import { Box, Container } from '@mui/material';
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useSettingsContext } from 'src/legacy/components/settings';
import { getCompanyUsers } from 'src/legacy/redux/slices/user';
import { useDispatch, useSelector } from 'src/legacy/redux/store';
import { useActiveCompany } from 'src/organization/hooks/useActiveCompany';

import { Breadcrumbs } from './Breadcrumbs';
import { ClientListNavigatorContextProvider } from './ClientListNavigatorContext';
import { Tabs } from './Tabs';

export const ClientListNavigator = () => {
  const dispatch = useDispatch();
  const { themeStretch } = useSettingsContext();

  const { activeCompany } = useActiveCompany();
  const { companyUsers } = useSelector((state) => state.user);

  useEffect(() => {
    if (activeCompany && !companyUsers) {
      dispatch(getCompanyUsers(activeCompany.id));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeCompany, companyUsers]);

  return (
    <ClientListNavigatorContextProvider>
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <Breadcrumbs />

        <Tabs />

        <Box>
          <Outlet />
        </Box>
      </Container>
    </ClientListNavigatorContextProvider>
  );
};
